import { render, staticRenderFns } from "./edit-article.vue?vue&type=template&id=0d1460da&scoped=true&"
import script from "./edit-article.vue?vue&type=script&lang=js&"
export * from "./edit-article.vue?vue&type=script&lang=js&"
import style0 from "./edit-article.vue?vue&type=style&index=0&id=0d1460da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1460da",
  null
  
)

export default component.exports